import { siteName, siteUrl, teamAuthor, companyName, companyUrl } from 'config/site';

export const buildFAQSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(({ question, answer }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: { '@type': 'Answer', text: answer },
  })),
});

export const buildArticleSchema = ({ title, description, url, datePublished, dateModified, author = teamAuthor, image }) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: title,
  description,
  url: `${siteUrl}${url}`,
  datePublished,
  dateModified: dateModified || datePublished,
  author: {
    '@type': 'Person',
    name: author,
    url: `${siteUrl}/about-author`,
  },
  publisher: {
    '@type': 'Organization',
    name: siteName,
    logo: { '@type': 'ImageObject', url: `${siteUrl}/logo.png` },
  },
  image: image || `${siteUrl}/og-image.jpg`,
  mainEntityOfPage: { '@type': 'WebPage', '@id': `${siteUrl}${url}` },
});

export const buildSoftwareAppSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: siteName,
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web Browser',
  url: siteUrl,
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'USD',
    description: 'Free to create. Pay only to download.',
  },
  creator: {
    '@type': 'Organization',
    name: companyName,
    url: companyUrl,
  },
  featureList: [
    'AI-Powered Resume Generation',
    'ATS Optimization',
    'Multiple Resume Templates',
    'PDF Download',
    'No Subscription Required',
    'Real-time Preview',
  ],
});

export const buildHowToSchema = ({ name, description, steps }) => ({
  '@context': 'https://schema.org',
  '@type': 'HowTo',
  name,
  description,
  step: steps.map((step, i) => ({
    '@type': 'HowToStep',
    position: i + 1,
    name: step.name,
    text: step.text,
  })),
});
